import { LanguageProvider, useLang } from "@/i18n/LanguageContext";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";
import ContactForm from "@/components/site/ContactForm";
import { Mail, MapPin, Building2 } from "lucide-react";
import { useSeo, ORG_SCHEMA } from "@/lib/seo";

const ContactContent = () => {
  const { t, lang } = useLang();
  useSeo(lang, {
    title: lang === "nl" ? "Contact | Demo aanvragen | Tribeo" : "Contact Tribeo | Book a Demo or Ask a Question",
    description: lang === "nl"
      ? "Vragen over Tribeo? Neem contact op voor een demo, partnerschap of andere vragen. We reageren binnen één werkdag."
      : "Questions about Tribeo? Get in touch for a demo, a partnership or a general question. We respond within one business day.",
    ogTitle: lang === "nl" ? "Neem contact op | Tribeo" : "Contact Tribeo",
    ogDescription: lang === "nl"
      ? "Demo aanvragen of een vraag stellen? We reageren binnen één werkdag. hello@tribeo.co"
      : "Questions or a demo request? hello@tribeo.co. We respond within one business day.",
    keywords: lang === "nl" ? "tribeo contact, tribeo demo aanvragen" : "tribeo contact, tribeo demo request, book tribeo demo",
    nlPath: "/contact",
    enPath: "/en/contact",
    jsonLd: ORG_SCHEMA,
  });

  return (
    <div className="container max-w-5xl py-32 md:py-40">
      <h1 className="text-4xl md:text-6xl font-extrabold leading-[1.05]">{t.contact.title}</h1>
      <p className="mt-5 text-lg md:text-xl text-muted-foreground max-w-2xl">{t.contact.subtitle}</p>

      <div className="mt-14 grid lg:grid-cols-2 gap-10">
        <div className="space-y-5">
          <div className="rounded-2xl bg-secondary p-5 flex items-start gap-4">
            <div className="h-10 w-10 rounded-xl bg-primary text-primary-foreground flex items-center justify-center shrink-0"><Mail className="h-5 w-5" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-muted-foreground font-bold">{t.contact.emailLabel}</div>
              <a href="mailto:hello@tribeo.co" className="text-base font-bold hover:underline">hello@tribeo.co</a>
            </div>
          </div>
          <div className="rounded-2xl bg-secondary p-5 flex items-start gap-4">
            <div className="h-10 w-10 rounded-xl bg-primary text-primary-foreground flex items-center justify-center shrink-0"><MapPin className="h-5 w-5" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-muted-foreground font-bold">{t.contact.addressLabel}</div>
              <div className="text-base font-bold">TNA B.V.</div>
              <div className="text-sm text-muted-foreground">Santiagosingel 26<br />2548HN Den Haag<br />Nederland</div>
            </div>
          </div>
          <div className="rounded-2xl bg-secondary p-5 flex items-start gap-4">
            <div className="h-10 w-10 rounded-xl bg-primary text-primary-foreground flex items-center justify-center shrink-0"><Building2 className="h-5 w-5" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-muted-foreground font-bold">{t.contact.kvkLabel}</div>
              <div className="text-base font-bold">75729814</div>
            </div>
          </div>
        </div>

        <div className="rounded-3xl bg-background border border-border shadow-card p-6 md:p-8">
          <h2 className="text-2xl font-extrabold">{t.contact.formTitle}</h2>
          <div className="mt-6">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

const Contact = () => (
  <LanguageProvider>
    <div className="min-h-screen bg-background">
      <Header />
      <main><ContactContent /></main>
      <Footer />
      <CookieBanner />
    </div>
  </LanguageProvider>
);

export default Contact;
